import { toHeaders, doFetch } from '../utils/util';

const FILE_UPLOAD_URL = '/file/upload';
const FILE_CHECK_URL = '/file/check';

export class FileService {

    constructor(auth) {
        this.auth = auth;
    }

    async upload(payload) {
        return await doFetch(FILE_UPLOAD_URL, {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async check(payload) {
        return await doFetch(FILE_CHECK_URL, {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async uploadMany(payload) {
        return await doFetch(FILE_UPLOAD_URL + '/many', {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async checkMany(payload) {
        return await doFetch(FILE_CHECK_URL + '/many', {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

}